<template>
  <div class="sidebar" v-show="FullScreenShow">
    <el-menu
      class="sidebar-el-menu"
      :default-active="onRoutes"
      :collapse="collapse"
      background-color="#324157"
      text-color="#bfcbd9"
      active-text-color="#20a0ff"
      unique-opened
    >
      <template v-for="item in items">
        <template v-if="item.children">
          <el-submenu :index="item.index" :key="item.index" @click="$router.push(item.index)">
            <template slot="title" @click="$router.push(item.index)">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.name }}</span>
            </template>
            <template v-for="subItem in item.children">
              <el-submenu
                v-if="subItem.children"
                :index="subItem.index"
                :key="subItem.index"
                @click="$router.push(subItem.index)"
              >
                <template slot="title" @click="$router.push(subItem.index)">{{ subItem.title }}</template>
                <el-menu-item
                  v-for="(threeItem,i) in subItem.children"
                  :key="i"
                  :index="threeItem.index"
                  @click="$router.push(threeItem.index)"
                >{{ threeItem.title }}</el-menu-item>
              </el-submenu>
              <el-menu-item
                v-else
                :index="subItem.index"
                :key="subItem.index"
                @click="$router.push(subItem.index)"
              >{{ subItem.title }}</el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else @click="$router.push(item.index)">
          <el-menu-item :index="item.index" :key="item.index" @click="$router.push(item.index)">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.title ? item.title : item.name }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
// import bus from '../common/bus';
// import {LOGIN} from '@/store/user/types'
// import store from '../store/index'
import {
// GETINFO,
} from '../store/user/types'
import toggle from '../store/toggle/index'
import user from '../store/user/index'
import Template from '../page/Template.vue'

export default {
  components: { Template },
  data () {
    return {
      collapse: false,
      items: [
        {
          // icon: 'el-icon-lx-home',
          index: '/',
          title: '首页'
        }
        // {
        //   // icon: 'el-icon-lx-home',
        //   title: '用户管理',
        //   index: '1',
        //   children: [
        //     {
        //       index: '/userdata/teacherlist',
        //       title: '教师列表'
        //     }
        //   ]
        // }
        // {
        //   // icon: 'el-icon-lx-home',
        //   title: '3端基础配置',
        //   index: '2',
        //   children: [
        //     {
        //       index: '/allTerminalConfig/schoolpermissions',
        //       title: '学校端权限编辑'
        //     }
        //   ]
        // }
      ]
    }
  },
  computed: {
    menuList () {
      return user.state.userinfo.menuList
    },
    silderToggle () {
      return toggle.state.sliderToggle
    },
    // 获取index值
    onRoutes () {
      return this.$route.path
    },
    // 是否开启全屏
    FullScreenShow () {
      return user.state.FullScreenShow
    }
  },
  watch: {
    menuList: {
      deep: true,
      handler () {
        this.getMenuList()
      }
    }
  },
  created () {
    this.getMenuList()
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    // bus.$on('collapse', msg => {
    //     this.collapse = msg;
    //     bus.$emit('collapse-content', msg);
    // });
  },
  mounted () {
    // // 获取用户信息
    // let params = {
    //   accout: localStorage.getItem('accout'),
    //   password: localStorage.getItem('password')
    // }
    // this.$store.dispatch(LOGIN, params)
    // // 获取地区列表
    // this.getRegionList()
  },
  methods: {
    // 获取菜单信息
    getMenuList () {
      let menuList = (this.menuList && this.menuList.length) ? this.menuList.filter((x) => x.flag === 1) : [] // this.menuList // (this.menuList && this.menuList.length) ? this.menuList.filter((x) => x.flag === 1) : []
      // menuList = menuList.filter(x => {
      //   return (x.name === '库内作业' && (user.state.userinfo.isMdOpen === 1 || user.state.userinfo.isLmOpen === 1)) || (x.name !== '库内作业')
      // })
      menuList.map((v, i) => {
        if (v.status === 1) {
          // 一级菜单
          if (v.url && v.url !== '') {
            menuList[i].index = v.url
            menuList[i].title = v.name
          } else {
            // 目录
            menuList[i].index = (i + 1).toString()
            // 二级菜单
            if (v.children && v.children.length) {
              v.children.map((vv, ii) => {
                // if (vv.status !== 1) {
                //   v.children.splice(ii, 1)
                // } else if ((vv.url === '/rollsHomework/productionDateEntry' && user.state.userinfo.isMdOpen === 1) || (vv.url === '/rollsHomework/productionDateEntry' && user.state.userinfo.identity === 4)) {
                //   v.children[ii].index = vv.url
                //   v.children[ii].title = vv.name
                // } else if ((vv.url === '/rollsHomework/putawayList' && user.state.userinfo.isLmOpen === 1) || (vv.url === '/rollsHomework/putawayList' && user.state.userinfo.identity === 4)) {
                //   v.children[ii].index = vv.url
                //   v.children[ii].title = vv.name
                // } else if (vv.url !== '/rollsHomework/productionDateEntry' && vv.url !== '/rollsHomework/putawayList') { // 不是仓管员时显示上架单和生产日期管理菜单
                //   v.children[ii].index = vv.url
                //   v.children[ii].title = vv.name
                // } else {
                //   v.children.splice(ii, 1)
                // }
                if (vv.status === 1) {
                  v.children[ii].index = vv.url
                  v.children[ii].title = vv.name
                } else {
                  v.children.splice(ii, 1)
                }
              })
            }
          }
        } else {
          menuList.splice(v, 1)
        }
      })
      // console.log(menuList, '菜单')
      // console.log(menuList, 'menuLis2')
      this.items = [
        {
          index: '/',
          title: '首页'
        }
      ]
      let items = this.items.concat(menuList)
      this.items = items
    }
  }
}
</script>

<style scoped>
  .sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 100px;
    bottom: 0;
    background-color: #fff;
    overflow-y: scroll;
    z-index: 5;
  }
  .sidebar::-webkit-scrollbar {
    width: 0;
  }
  .sidebar-el-menu:not(.el-menu--collapse) {
    width: 250px;
    background-color: #fff !important;
  }
  .sidebar > ul {
    height: 100%;
  }
  .el-submenu .el-menu-item {
    padding: 0;
  }
  .el-menu-item,
  .sidebar-el-menu >>> .el-submenu__title {
    background-color: #fff !important;
    color: #222 !important;
  }
  .el-menu .el-submenu >>> .el-menu--inline {
    background-color: #fff !important;
  }
  .el-menu .el-submenu.is-active .is-active {
    color: #fff !important;
    background-color: #499ed6 !important;
    /* border-radius: 30px; */
    /* margin: 0px 15px; */
  }
</style>



// WEBPACK FOOTER //
// src/layout/Sidebar.vue